export const POST_COMMENT_START = 'POST_COMMENT_START';
export const POST_COMMENT_SUCCESS = 'POST_COMMENT_SUCCESS';
export const POST_COMMENT_ERROR = 'POST_COMMENT_ERROR';
export const POST_COMMENT_END = 'POST_COMMENT_END';
export const POST_COMMENT_CLEAR = 'POST_COMMENT_CLEAR';
